import PropTypes from 'prop-types';
import { Box, Typography, Stack, Tooltip, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';

export function FooterBottomBar({ user, openFeedbackModal, socialLinks }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2,
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1, sm: 3 }}
                sx={{ alignItems: 'center', textAlign: { xs: 'center', sm: 'left' } }}
            >
                <Typography variant="body2" sx={{ color: 'grey.500' }}>
                    © {new Date().getFullYear()} TAS Ski Team. All Rights Reserved.
                </Typography>
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: { xs: 'center', sm: 'flex-start' },
                        rowGap: 0.5,
                    }}
                >
                    <Typography
                        component={Link}
                        to="/privacy"
                        variant="body2"
                        sx={{
                            color: 'grey.400',
                            textDecoration: 'none',
                            transition: 'color 0.2s',
                            '&:hover': { color: 'white' },
                        }}
                    >
                        Privacy Policy
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'grey.600' }}>
                        •
                    </Typography>
                    <Typography
                        component={Link}
                        to="/terms"
                        variant="body2"
                        sx={{
                            color: 'grey.400',
                            textDecoration: 'none',
                            transition: 'color 0.2s',
                            '&:hover': { color: 'white' },
                        }}
                    >
                        Terms
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'grey.600' }}>
                        •
                    </Typography>
                    <Typography
                        component={Link}
                        to="/known-issues"
                        variant="body2"
                        sx={{
                            color: 'grey.400',
                            textDecoration: 'none',
                            transition: 'color 0.2s',
                            '&:hover': { color: 'white' },
                        }}
                    >
                        Known Issues
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'grey.600' }}>
                        •
                    </Typography>
                    <Typography
                        component={Link}
                        to={user ? '#' : '/login'}
                        onClick={user ? (e) => { e.preventDefault(); openFeedbackModal('bug'); } : undefined}
                        variant="body2"
                        aria-label="Report an Issue or Feedback"
                        sx={{
                            color: 'grey.400',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            transition: 'color 0.2s',
                            '&:hover': { color: 'white' },
                        }}
                    >
                        Report an Issue / Feedback
                    </Typography>
                </Stack>
            </Stack>

            {/* Social Links */}
            <Stack direction="row" spacing={1}>
                {socialLinks.map((social) => {
                    const IconComponent = social.icon;
                    return (
                        <Tooltip key={social.label} title={social.label} arrow>
                            <IconButton
                                component="a"
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`TAS Ski on ${social.label}`}
                                sx={{
                                    color: 'grey.400',
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                        color: 'white',
                                        bgcolor: 'accent.main',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <IconComponent />
                            </IconButton>
                        </Tooltip>
                    );
                })}
            </Stack>
        </Box>
    );
}

FooterBottomBar.propTypes = {
    user: PropTypes.object,
    openFeedbackModal: PropTypes.func.isRequired,
    socialLinks: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.elementType.isRequired,
        url: PropTypes.string.isRequired,
    })).isRequired,
};

export default FooterBottomBar;
